import React from 'react';
import { Box, InlineStack } from '@shopify/polaris';
import CreditsInfo from '@/components/CreditsInfo';

type HeaderProps = React.HTMLAttributes<HTMLDivElement>;

const Header: React.FC<HeaderProps> = ({ className }) => {
  return (
    <header className={className}>
      <Box padding="400">
        <InlineStack align="space-between" gap="600">
          <div></div>
          <CreditsInfo />
        </InlineStack>
      </Box>
    </header>
  );
};

export default Header;
